module.exports = __webpack_public_path__ + "static/10-2b4d4b7deccbc3c545005a909ac35a63.wav";